<template>
  <div class="mdl-accordion mdl-accordion--opened mdl-shadow--2dp">
    <a class="mdl-accordion__button" @click="toggleAccordion">
      <i class="material-icons mdl-accordion__icon mdl-animation--default">expand_more</i>
      <strong>{{ data.nombre }}</strong>
    </a>
    <div class="mdl-accordion__content-wrapper">
      <div class="mdl-accordion__content mdl-animation--default"
        v-for="(especificacion, i) in data.especificaciones"
        :id="'especificacion-' + especificacion.id"
        :key="especificacion.id">
        <a class="mdl-accordion__link">
          <span class="mdl-accordion__link-title">{{ especificacion.nombre }}</span>
          <button type="button"
            :class="['current-chip', 'mdl-chip', 'mdl-color--' + especificacion.selected.color]"
            @click="openChips"></button>
          <div class="mdl-chip__buttons" :data-i="i">
            <button v-for="(ponderacion, j) in especificacion.ponderaciones"
              type="button"
              :class="['mdl-chip', 'mdl-color--' + ponderacion.color]"
              :data-id="ponderacion.id"
              :data-color="ponderacion.color"
              :data-value="ponderacion.valor"
              @click="chipSelected"
              :key="ponderacion.id"></button>
          </div>
        </a>
        <div :class="['incidence', 'mdl-grid',
                    especificacion.selected.color.match(/red|yellow/)
                    ? 'incidence--opened'
                    : '']">
          <div v-show="especificacion.imagenes.length === 0"
            class="mdl-cell mdl-cell--12-col">
            <h1 class="mdl-typography--text-center">
              <i class="material-icons">photo</i>
            </h1>
            <p class="mdl-typography--text-center">
              Puedes agregar hasta 3 imágenes como evidencia fotográfica<br>
              para justificar tu calificación.
            </p>
          </div>
          <div v-show="especificacion.imagenes.length > 0"
            class="photos mdl-cell mdl-cell--12-col">
            <div class="mdl-card mdl-shadow--2dp"
              v-for="(imagen, k) in especificacion.imagenes"
              :style="{ background: 'url(' + imagen + ') center / cover' }"
              :key="k">
              <div class="mdl-card__title mdl-card--expand"></div>
              <div class="mdl-card__actions">
                <span class="mdl-card__filename">
                  {{ 'Imagen #' + (k+1) + ' de la incidencia.' }}
                </span>
              </div>
              <div class="mdl-card__menu" style="left: 16px;">
                <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
                  :data-i="i" :data-k="k" @click="downloadPicture">
                  <i class="material-icons">file_download</i>
                </button>
              </div>
              <div class="mdl-card__menu">
                <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
                  :data-i="i" :data-k="k" @click="removePicture">
                  <i class="material-icons">delete</i>
                </button>
              </div>
            </div>
            <!-- <img v-for="(image, j) in ponderacion.images" :key="j"
              :src="image" :alt="'Imagen #' + j + ' de la incidencia.'"> -->
          </div>
          <div class="mdl-cell mdl-cell--12-col mdl-typography--text-center">
            <button type="button" @click="uploadPicture"
              class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored">
              Agregar Fotografía(s)
              <input type="file" accept="image/*" class="hidden"
                :data-i="i"
                @change="showPicture">
            </button>
          </div>
          <div class="comments mdl-cell mdl-cell--12-col">
            <img :src="$user.data.avatar || './img/profile-64.png'" class="avatar">
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <textarea class="mdl-textfield__input" type="text" rows= "3"
                v-model="especificacion.observaciones"></textarea>
              <label class="mdl-textfield__label">Escribe tus observaciones aquí...</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tree', 'data', 'index'],
  data () {
    return {
      currentIndex: 0
    }
  },
  methods: {
    adjustAccordions () {
      let contents = document.querySelectorAll('.mdl-accordion__content')
      for (var i = contents.length - 1; i >= 0; i--) {
        let content = contents[i]
        content.style.marginTop = -1 * content.offsetHeight + 'px'
      }
    },
    toggleAccordion (event) {
      event.target.parentNode.classList.toggle('mdl-accordion--opened')
    },
    openChips (event) {
      let chipsContainer = event.target.parentNode.querySelector('.mdl-chip__buttons')
      chipsContainer.classList.add('mdl-chip__buttons--opened')
    },
    chipSelected (event) {
      let chipSelected = event.target,
          chipsContainer = chipSelected.parentNode,
          currentChip = chipsContainer.parentNode.querySelector('.current-chip'),
          content = currentChip.parentNode.parentNode,
          incidence = content.querySelector('.incidence'),
          i = chipsContainer.dataset.i,
          especificacion = this.data.especificaciones[i]

      especificacion.selected.color = chipSelected.dataset.color
      especificacion.selected.id = chipSelected.dataset.id
      especificacion.selected.valor = 1 * chipSelected.dataset.value
      chipsContainer.classList.remove('mdl-chip__buttons--opened')

      if (especificacion.selected.color.match(/red|yellow/)) {
        incidence.classList.add('incidence--opened')
      } else {
        incidence.classList.remove('incidence--opened')
      }

      content.style.marginTop = -1 * content.offsetHeight + 'px'
      this.$emit("trigger", Math.random())
    },
    uploadPicture (event) {
      event.currentTarget.querySelector('input[type="file"]').click()
    },
    imageToDataUri (img, width, height, quality) {
      // create an off-screen canvas
      let canvas = document.createElement('canvas'),
          ctx = canvas.getContext('2d');

      // set its dimension to target size
      canvas.width = width;
      canvas.height = height;

      // draw source image into the off-screen canvas:
      ctx.drawImage(img, 0, 0, width, height);

      // encode image to data-uri with base64 version of compressed image
      return canvas.toDataURL('image/jpeg', quality);
    },
    showPicture (event) {
      // spinner.classList.remove('hidden');
      // selectPicture.disabled = true;
      // Get a reference to the taken picture or chosen file
      const self = this
      let fileInput = event.target,
          files = fileInput.files,
          file,
          fileSize,
          fileReader = new FileReader(),
          i = fileInput.dataset.i,
          especificacion = this.data.especificaciones[i]

      // especificacion.images = especificacion.images ? especificacion.images : []
      if (especificacion.imagenes.length >= 3) {
        return
      }

      if (files && files.length > 0) {
        file = files[0]
        fileSize = file.size

        fileReader.onload = function (event) {
          let img = new Image()
          // let anchor = document.createElement('a')
          let newDataUri
          const snackbar = {
            message: '¿Deseas descargar la imágen?',
            actionHandler: false,
            actionText: 'Descargar'
          }

          img.onload = (i) => {
            newDataUri = fileSize > 3000000
              ? self.imageToDataUri(img, img.width*0.25, img.height*0.25, 0.3)
              : newDataUri = self.imageToDataUri(img, img.width*0.5, img.height*0.5, 0.4)

            // showPicture.src = newDataUri;
            // showPicture.classList.remove('hidden');
            // selectPicture.disabled = false;
            especificacion.imagenes.push(newDataUri)

            setTimeout(() => {
              self.adjustAccordions()
            }, 1000)
            // self.$idb.keyVal.set(undefined, self.data)
            // console.log(especificacion.images)
          }

          img.src = fileReader.result
          // anchor.textContent = 'Descargar'
          // anchor.href = fileReader.result
          // anchor.download = self.tree.inmueble.nombre + '__' +
          //   self.tree.area.nombre + '__' +
          //   self.data.nombre + '__' +
          //   especificacion.nombre + '__' +
          //   (especificacion.imagenes.length + 1)
          // snackbar.actionHandler = () => { anchor.click() }
          // self.$snackbar.init(snackbar)
          // spinner.classList.add('hidden');
        }
        fileReader.readAsDataURL(file)
      } else {
        // Aqui la imagen se crea y luego te destruye.
        // spinner.classList.add('hidden');
        // selectPicture.disabled = false;
      }
    },
    downloadPicture (event) {
      let downloadButton = event.currentTarget,
          i = downloadButton.dataset.i,
          k = downloadButton.dataset.k,
          especificacion = this.data.especificaciones[i],
          imagenes = especificacion.imagenes,
          anchor = document.createElement('a')
          // url = imagenes[k].replace(/^data:image\/[^;]+/, 'data:application/octet-stream'),
          // win = window.open(imagenes[k], '_blank')

      anchor.href = imagenes[k]
      anchor.target = '_blank'
      anchor.download = this.tree.inmueble.nombre + '__' +
        this.tree.area.nombre + '__' +
        this.data.nombre + '__' +
        especificacion.nombre + '__' +
        (imagenes.length + 1)

      return anchor.click()


      // image.src = imagenes[k]

      // return win.document.write(image.outerHTML)
      // return window.open(imagenes[k], '_blank')
    },
    removePicture (event) {
      let deleteButton = event.currentTarget,
          i = deleteButton.dataset.i,
          k = deleteButton.dataset.k,
          especificacion = this.data.especificaciones[i],
          imagenes = especificacion.imagenes

      return imagenes.splice(k, 1)
    }
  },
  mounted () {
    this.adjustAccordions()
    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-button'))
    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-textfield'))
  }
}
</script>

<style lang="css" scoped>
  .mdl-layout__drawer {
    position: static;
    width: 100%;
  }

  .mdl-navigation {
    padding: 0;
  }

  .mdl-accordion {
    background-color: #fff;
    margin-bottom: 15px;
  }

  .mdl-accordion__link {
    flex-wrap: wrap;
  }

  .mdl-accordion__button,
  .mdl-accordion__link {
    position: relative;
    display: flex;
    padding: 16px;
    overflow: hidden;
  }

  .mdl-accordion .mdl-accordion__link .mdl-accordion__link-title {
    flex-grow: 2;
  }

  .mdl-accordion .mdl-accordion__link .mdl-chip {
    width: 32px;
    cursor: pointer;
  }

  .mdl-chip__buttons {
    display: none;
    position: absolute;
    top: 12px;
    right: 8px;
    padding: 0 6px;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),
      0 3px 1px -2px rgba(0,0,0,.2),
      0 1px 5px 0 rgba(0,0,0,.12);
    border-radius: 20px;
    overflow: hidden;
  }

  .mdl-chip__buttons--opened {
    display: block;
  }

  .mdl-chip__buttons .mdl-chip {
    margin: 6px 2px;
  }

  .incidence {
    display: none;
    width: 100%;
    background-color: #f3f3f3;
  }

  .incidence--opened {
    display: block;
  }

  .incidence h1 i {
    font-size: 6rem;
    color: rgb(148, 144, 148);
    opacity: 0.25;
  }

  .incidence .mdl-cell h1,
  .incidence .mdl-cell p {
    margin: 0;
  }

  .incidence .comments {
    display: flex;
    flex-direction: row;
    /*padding: 0 2rem;*/
  }

  .incidence .comments .avatar {
    width: 48px;
    height: 48px;
    margin: 10px;
    border-radius: 24px;
  }

  .incidence .comments .mdl-textfield {
    flex-grow: 2;
  }

  .photos {
    display: flex;
    flex-wrap: wrap;
  }

  .photos .mdl-card {
    width: 256px;
    height: 256px;
    margin: 5px auto;
    /*background: url('../assets/demos/image_card.jpg') center / cover;*/
    /*background-position: center;
    background-repeat: cover;*/
  }

  .photos .mdl-card__actions {
    height: 52px;
    padding: 16px;
    background: rgba(0, 0, 0, 0.2);
  }

  .photos .mdl-card__filename {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
  }

  .photos .mdl-card__menu {
    color: #fff;
  }
</style>


// WEBPACK FOOTER //
// Accordion.vue?e8bafeb0